import { AccountService, NotificationService } from "@3gaam/api/services";
import { config } from "@3gaam/capp/src/config";
import { store } from "@3gaam/capp/src/store";
import { setIsLoggedInAction } from "@3gaam/capp/src/store/auth";
import { useAppSelector } from "@3gaam/capp/src/store/hooks";
import Logo from "@3gaam/shared/assets/images/3gaam-logo.svg";
import Icon from "@3gaam/shared/components/general/icon";
import IframeModal from "@3gaam/shared/components/general/iframeModal";
import Image from "@3gaam/shared/components/general/image";
import { isInitialized, unsubscribe } from "@3gaam/shared/utils/firebase";
import React, { useState } from "react";
import { ROUTES } from "../../../constants";
import DrawerItem from "./drawerItem";

const doLogout = () => {
  let clientId = JSON.parse(
    localStorage.getItem("notificationData") || "{}",
  ).ClientId;

  if (isInitialized()) {
    unsubscribe()
      .then(() => {
        if (clientId) {
          NotificationService.unRegister({
            CurrentClientId: clientId,
          }).catch(() => {});
        }
      })
      .catch(() => {})
      .finally(() => {
        AccountService.logout({}).finally(() => {
          store.dispatch(setIsLoggedInAction(false));
          localStorage.clear();
        });
      });
  } else {
    AccountService.logout({}).finally(() => {
      store.dispatch(setIsLoggedInAction(false));
      localStorage.clear();
    });
  }
};

type Props = {
  showDrawer: boolean;
  setShowDrawer: (show: boolean) => void;
};

const Drawer = ({ showDrawer, setShowDrawer }: Props) => {
  const [showAutomationModal, setShowAutomationModal] =
    useState<boolean>(false);

  const counselorData = useAppSelector(
    // @ts-ignore
    (state) => state.consultee.applicant?.Counselor,
  );


  return (
    <>
      <div
        className={`drawer-bg ${showDrawer ? "show" : ""}`}
        onClick={() => {
          setShowDrawer(false);
        }}
      />
      <div
        className={`drawer d-block font-13 overflow-auto ${
          showDrawer ? "show" : ""
        }`}
        style={{ zIndex: 2000000005 }}
      >
        <div
          className="bg-lightblue d-flex align-items-center justify-content-center"
          style={{ height: 136 }}
        >
          <Image src={Logo} style={{ width: 115 }} alt="۳گام" />
        </div>
        <div onClick={() => setShowDrawer(false)} className="navigation-menu">
          <a
            href={`${config.hallUrl}/${counselorData?.Slug}`}
            className="d-flex align-items-center dropdown-item cur-pinter cur-pointer px-4 py-3"
            rel="noreferrer"
          >
            <span className="d-inline-flex font-16 ml-3 text-gray3">
              <Icon name="FA_R-landmark" />
            </span>
            صفحه من
          </a>

          <a
            target="_blank"
            className="d-flex align-items-center dropdown-item cur-pinter cur-pointer px-4 py-3"
            rel="noreferrer"
            onClick={() => {
              setShowDrawer(false);
              setShowAutomationModal(true);
            }}
          >
            <span className="d-inline-flex font-16 ml-3 text-gray3">
              <Icon name="FA_R-folder-gear" />
            </span>
            اتوماسیون
          </a>
          <DrawerItem
            item={{
              label: "کلاس‌ها و پروژه‌ها",
              icon: "FA_R-screen-users",
              path: ROUTES.USER_PRODUCT.PATH,
            }}
          />
          <DrawerItem
            item={{
              path: ROUTES.USER_RATES.PATH,
              label: "نظرات کاربران",
              icon: "FA_R-comment-lines",
            }}
            key="نظرات کاربران"
          />
          <DrawerItem
            item={{
              label: "روتین کاری",
              icon: "FA_R-clock",
              path: ROUTES.ROUTINES.PATH,
            }}
          />
          <DrawerItem
            item={{
              label: "گزارش مالی",
              icon: "FA_R-receipt",
              path: ROUTES.PAYMENT.PATH,
            }}
          />
          <DrawerItem
            item={{
              label: "کاربران (نسخه قدیم)",
              icon: "FA_R-users",
              path: ROUTES.CONSULTANTS_USERS.PATH,
            }}
          />
          <DrawerItem
            item={{
              label: "سایر کارها",
              icon: "FA_R-list-check",
              path: ROUTES.CRMEVENT_REQUEST.PATH,
            }}
          />

          <div
            onClick={doLogout}
            className="d-flex align-items-center dropdown-item cur-pinter cur-pointer px-4 py-3"
          >
            <span className="d-inline-flex font-16 ml-3 text-gray3">
              <Icon name="FA_R-arrow-right-from-bracket" />
            </span>
            خروج از حساب
          </div>
        </div>
      </div>
      <IframeModal
        title="اتوماسیون"
        show={showAutomationModal}
        src={`/automationForm.html?CounselorName=${
          counselorData?.Fullname || ""
        }&CounselorMobile=${counselorData?.Mobile || ""}`}
        onClose={() => {
          setShowAutomationModal(false);
        }}
      />
    </>
  );
};

export default React.memo(Drawer);
